import moment from "moment";
import React from "react";
import "../../assets/css/ribbon/ribbon.css";
import ScheduleItem from "./scheduleItem";

const ListSchedule = (props: { type: string; schedule: any }) => {
  const { type, schedule }: any = props;
  // console.log(schedule.year);

  return (
    <>
      {/* รอ loop แล้วส่งไปให้ ScheduleItem อาจจะทำเป็น obj ไปเพื่อจะไม่ได้ต้องส่ง prop หลายตัว */}
      <ScheduleItem schedule={schedule} type={type} />
    </>
  );
};

export default ListSchedule;
